import { AlertSpg, GridItem } from "@duosoftbg/nacid-components";
import { IconButton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const UsersDialogList = ({ users, isEdit, onRemove = (user) => {} }) => {
  const { t } = useTranslation();

  return (
    <>
      {users && users.length > 0 ? (
        users.map((user) => (
          <GridItem sm={6} md={4} lg={4} key={user.id}>
            <Typography component={"span"} fontSize={16}>
              {user.username + " (" + user.fullName + ")"}
            </Typography>
            {isEdit ? (
              <Typography component={"span"} fontSize={16}>
                <IconButton
                  title={t("l.btn.remove")}
                  color={"error"}
                  style={{ position: "relative" }}
                  onClick={(e) => onRemove(user)}
                >
                  <FontAwesomeIcon style={{ fontSize: 20 }} icon={faXmark} />
                </IconButton>
              </Typography>
            ) : null}
          </GridItem>
        ))
      ) : (
        <GridItem sm={12} md={12} lg={12} paddingLeft={"10px"}>
          <AlertSpg severity="info">{t("m.empty.list")}</AlertSpg>
        </GridItem>
      )}
    </>
  );
};
export default UsersDialogList;
